import TextStyling from './TextStyling';

const OverviewModule = ({
  coverageAmount = '',
  coverageAmountHeader = '',
  coverageDetails = {},
  coverageListHeader = '',
  coverageListItems = [],
  premiumAmount = '',
  premiumAmountHeader = '',
  title = '',
} = {}) => ({
  coverageAmountHeader: String(coverageAmountHeader),
  coverageAmount: String(coverageAmount),
  coverageDetails: TextStyling(coverageDetails),
  coverageListHeader: String(coverageListHeader),
  coverageListItems: coverageListItems.map((item) => TextStyling(item)),
  premiumAmountHeader: String(premiumAmountHeader),
  premiumAmount: String(premiumAmount),
  title: String(title),
});

export type OverviewModuleProps = ReturnType<typeof OverviewModule>;

export default OverviewModule;
